import { Outlet } from 'react-router';

import { BrandMark } from './BrandMark';
import { publicConfig } from '../config/env';

export function AppLayout() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <BrandMark />
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <a href={publicConfig.termsUrl} rel="noreferrer" target="_blank">
          Terms
        </a>
        <a href={publicConfig.privacyUrl} rel="noreferrer" target="_blank">
          Privacy
        </a>
      </footer>
    </div>
  );
}
